// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
import store from '@/bootstrap/vuex';
import payrollBatchPayments from './payroll-batch-payments.js';

export default [
    {
        path: '/:organisation/hr/payrolls',
        component: () =>
            import('@/pages/[organisation]/hr/payrolls.vue'),
        name: 'human-resource.payrolls.search-payrolls',
        meta: {
            loginRequired: true,
            permission: 'access.payroll.view-payrolls',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/hr/payrolls/new.vue'),
                name: 'human-resource.payrolls.create-payroll',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.import-p45',
                },
            },
            {
                path: 'adjustments',
                component: () =>
                    import(/* webpackChunkName: "human-resource.payrolls" */ '@/pages/[organisation]/hr/payrolls/payroll-adjustments/new.vue'),
                name: 'human-resource.payrolls.create-payroll-adjustments',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.import-p45',
                },
                beforeEnter: (to, from, next) => {
                    if (store.state.payroll.payroll_pay_period_id == '') {
                        return next({ name: 'human-resource.payrolls.create-payroll' });
                    }

                    next();
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "human-resource.payrolls" */ '@/pages/[organisation]/hr/payrolls/payroll/[id].vue'),
                name: 'human-resource.payrolls.view-payroll',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.view-payrolls',
                },
            },
            {
                path: ':id/report',
                component: () =>
                    import(/* webpackChunkName: "human-resource.payrolls" */ '@/pages/[organisation]/hr/payrolls/payroll-report.vue'),
                name: 'human-resource.payrolls.payroll-report',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.view-payrolls',
                },
            },
            {
                path: ':id/batch/:batchId',
                component: () =>
                    import(/* webpackChunkName: "human-resource.payrolls" */ '@/pages/[organisation]/hr/payrolls/payroll-batch/[id].vue'),
                name: 'human-resource.payrolls.view-payroll-batch',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.view-payrolls',
                },
            },
            {
                path: ':id/batch/:batchId/payroll-register',
                component: () =>
                    import(/* webpackChunkName: "human-resource.payrolls" */ '@/pages/[organisation]/hr/payrolls/payroll-register/[id].vue'),
                name: 'human-resource.payrolls.view-payroll-register',
                meta: {
                    loginRequired: true,
                    permission: 'access.payroll.view-payrolls',
                },
            },
            ...payrollBatchPayments,
        ],
    },
    {
        path: '/:organisation/hr/import-p45',
        component: () =>
            import('@/pages/[organisation]/hr/import-p45.vue'),
        name: 'human-resource.payrolls.import-p45',
        meta: {
            loginRequired: true,
            permission: 'access.payroll.import-p45',
        },
    },
];
